import { render, staticRenderFns } from "./OrdersReportDashboard.vue?vue&type=template&id=a8673366&scoped=true&"
import script from "./OrdersReportDashboard.vue?vue&type=script&lang=js&"
export * from "./OrdersReportDashboard.vue?vue&type=script&lang=js&"
import style0 from "./OrdersReportDashboard.vue?vue&type=style&index=0&id=a8673366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8673366",
  null
  
)

export default component.exports